/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import MaterialTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import Modal from '../../shared/components/Modal';

const ClassPlan = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const addItemClickHandler = () => {
    history.push('/minime/plano-aula/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/plano-aula/mnt/${rowData.id}`);
  };

  const loadData = () => {};

  const toggleModal = () => {
    setModal(!modal);
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const deleteItem = () => {
    showLoading();
    hideLoading();
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    title={t('panels.plano-aula')}
                    data={data}
                    columns={columns(t)}
                    onRefreshClick={loadData()}
                    pageSize={DEFAULT_PAGE_SIZE}
                    deleteAction={toggleModal}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

ClassPlan.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ClassPlan)
);
